import { render, staticRenderFns } from "./ItemListLikeLayout.vue?vue&type=template&id=2c6a3a65&scoped=true&"
import script from "./ItemListLikeLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListLikeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a3a65",
  null
  
)

export default component.exports